var React = require('react');

function GitCommitOutline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"git commit"),React.createElement("circle",{"cx":"256","cy":"256","r":"96","style":{"fill":"none","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32px"},"key":1}),React.createElement("line",{"x1":"160","y1":"256","x2":"48","y2":"256","style":{"fill":"none","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32px"},"key":2}),React.createElement("line",{"x1":"464","y1":"256","x2":"352","y2":"256","style":{"fill":"none","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32px"},"key":3})]);
}

GitCommitOutline.defaultProps = {"width":"512","height":"512","viewBox":"0 0 512 512"};

module.exports = GitCommitOutline;

GitCommitOutline.default = GitCommitOutline;
